export default __webpack_public_path__ + "img/0f0fca781e65c80b5a2dbe2cbd514cfa.png";